import React, { useState } from 'react';
import { Section, Image, Link, OnVisible } from 'components';
import * as styles from './styles.module.scss';

const TwoColTabbed = (props) => {
  const { data } = props;
  const { primary, items } = data;
  const [activeIndex, setActiveIndex] = useState(0);

  const { background_color: bgColour } = primary || {};

  const activeItem = items[activeIndex];
  const {
    tab_title: tabTitle,
    tab_content: tabContent,
    cta_text: ctaText,
    cta_link: ctaLink,
    tab_image: tabImage,
  } = activeItem || {};

  // content checks
  const titleHtml = tabTitle?.html;
  const contentHtml = tabContent?.html;
  const hasCta = ctaText?.text && ctaLink?.url;
  const imageUrl = tabImage?.url;

  const formattedBg = bgColour ? bgColour.toLowerCase() : '';
  const bgClasses = {
    'off white': styles.offWhite,
    white: styles.white,
  };

  return (
    <Section
      sliceName="TwoColTabbed"
      className={`${bgClasses[formattedBg]} ${styles.section}`}
      containerClassName={styles.container}
    >
      {/*  content */}
      <OnVisible visibleClassName={styles.visible} className={styles.content}>
        <header className={styles.header}>
          {titleHtml && <div dangerouslySetInnerHTML={{ __html: titleHtml }} className={styles.title} />}

          {/* tab buttons */}
          {items?.[0] && (
            <ul className={styles.tabs}>
              {items.map((item, index) => {
                const isActive = index === activeIndex;
                return (
                  <li key={`TwoColTabbed-tab-${index}`} className={styles.tabButton}>
                    <Link
                      className={`${styles.tab} button ${isActive ? 'black' : 'lightgray'}`}
                      onClick={() => setActiveIndex(index)}
                    >
                      {item?.tab_button_text?.text}
                    </Link>
                  </li>
                );
              })}
            </ul>
          )}

          {contentHtml && <div dangerouslySetInnerHTML={{ __html: contentHtml }} className={styles.tabContent} />}
        </header>

        {hasCta && (
          <Link className={`button ${styles.ctaButton}`} to={ctaLink?.url}>
            {ctaText?.text}
          </Link>
        )}
      </OnVisible>

      {/*  image */}

      {imageUrl && (
        <OnVisible visibleClassName={styles.visible} className={styles.image}>
          <Image image={tabImage} />
        </OnVisible>
      )}
    </Section>
  );
};

export default TwoColTabbed;
